import { render, staticRenderFns } from "./MultiPageItemSettings.vue?vue&type=template&id=51620aeb"
import script from "./MultiPageItemSettings.vue?vue&type=script&lang=js"
export * from "./MultiPageItemSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports